/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min read`)
};

const es_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min de lectura`)
};

const de_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. Lesezeit`)
};

const nl_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min leestijd`)
};

const fr_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min de lecture`)
};

const it_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min di lettura`)
};

const pt_br2_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min de leitura`)
};

const pt_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`min de leitura`)
};

const ja_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分で読めます`)
};

const zh_blog_minutes_read = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟阅读`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_minutes_read = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_minutes_read(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_minutes_read", locale)
	if (locale === "en") return en_blog_minutes_read(inputs)
	if (locale === "es") return es_blog_minutes_read(inputs)
	if (locale === "de") return de_blog_minutes_read(inputs)
	if (locale === "nl") return nl_blog_minutes_read(inputs)
	if (locale === "fr") return fr_blog_minutes_read(inputs)
	if (locale === "it") return it_blog_minutes_read(inputs)
	if (locale === "pt-BR") return pt_br2_blog_minutes_read(inputs)
	if (locale === "pt") return pt_blog_minutes_read(inputs)
	if (locale === "ja") return ja_blog_minutes_read(inputs)
	return zh_blog_minutes_read(inputs)
};